import { device } from 'constants/device';

import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.system.white};
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.system.lightGrey};
  border-radius: 18px;
  width: 400px;
  height: 368px;
  position: relative;

  &:hover {
    border: 1px solid ${({ theme }) => theme.brand.blue};
  }

  @media ${device.tablet} {
    width: 214px;
    height: 204px;
    border-radius: 8px;
    padding: 12px;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 12px;
  height: 100%;
  @media ${device.tablet} {
    margin-top: 8px;
  }
`;
